// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"zV","skip_info":"AV","skipped":"BV","modify_order":"CV","cancel_subscription_btn":"EV","byb":"FV","modify_order_outer":"GV","byb_edit_btn":"HV","modify_order_item":"IV","cancel_copy_wrapper":"JV","cancelled_copy":"KV"};
    if(module.hot) {
      // 1714442371141
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  